export var DocumentState;
(function (DocumentState) {
    DocumentState[DocumentState["Draft"] = 0] = "Draft";
    DocumentState[DocumentState["Open"] = 1] = "Open";
    DocumentState[DocumentState["Closed"] = 2] = "Closed";
    DocumentState[DocumentState["Ignored"] = 3] = "Ignored";
})(DocumentState || (DocumentState = {}));
